var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"free-form__content"},[_c('table-master-info',{attrs:{"scrId":_vm.scrId}}),_c('table-author-info',{staticClass:"my-2"}),_c('table-detail-info',{attrs:{"scrId":_vm.scrId}}),_c('table-appr-info',{staticClass:"my-2",attrs:{"scrId":_vm.scrId}}),_c('table-solution-info',{attrs:{"scrId":_vm.scrId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }